import React from 'react';
import ReactDOM from 'react-dom/client';
import { WindDriftPage } from './WindDriftPage';
import { SafeBoundary } from '@/components/SafeBoundary';
import { initMonitoring } from '@/lib/monitoring';
import '../index.css';

initMonitoring('wind-drift');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SafeBoundary section="Wind-Drift Visualizer">
      <WindDriftPage />
    </SafeBoundary>
  </React.StrictMode>
);
